/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.afterMergeHandler = this.handleAfterMerge.bind(this);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      if (window.BSS_B2B?.makeChangesAfterClickAjaxCart) {
        window.BSS_B2B.makeChangesAfterClickAjaxCart();
        setTimeout(() => window.BSS_B2B.makeChangesAfterClickAjaxCart(), 25);
      }
    });
    this.addEventListener('on:cart:after-merge', this.afterMergeHandler);
  }

  handleAfterMerge() {
    if (!this.isConnected) return;

    // Re-initialize deferred drawer content after cart markup has been merged.
    theme.manuallyLoadImages(this);
    this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    if (window.BSS_B2B?.makeChangesAfterClickAjaxCart) {
      window.BSS_B2B.makeChangesAfterClickAjaxCart();
      setTimeout(() => window.BSS_B2B.makeChangesAfterClickAjaxCart(), 25);
    }

    const emptyState = this.querySelector('.cart-drawer__empty-content');
    if (this.hasAttribute('open') && emptyState && !emptyState.classList.contains('cart-drawer__empty-content--hidden')) {
      this.close();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    this.removeEventListener('on:cart:after-merge', this.afterMergeHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
